export default __webpack_public_path__ + "static/media/Flutter.99b29fec.png";